/** @format */

import React, {
  useEffect,
  useMemo,
  useState,
  Suspense,
  ReactNode,
} from "react";
import { useParams } from "react-router-dom";

import { Alert, Spinner } from "react-bootstrap";
import FeatureFlag from "../featureFlag/FeatureFlag";
import { Card, CardType, Resource, UserResource } from "../resources/types";
import ContentEditor from "../contentEditor/contentEditor";
/* import { useAppDispatch } from '../../app/hooks';
import { setIsEditable } from '../editable/editableSlice'; */

interface RouteParams {
  cardType: string;
}

const Dev = () => {
  const staticTypes = useMemo(() => ["Read", "Write"], []);
  const { cardType } = useParams<keyof RouteParams>() as RouteParams;
  const type = useMemo(() => {
    if (staticTypes.includes(cardType)) {
      return "Static";
    } else {
      return cardType?.charAt(0).toUpperCase() + cardType?.slice(1);
    }
  }, [cardType, staticTypes]);

  const [jsonError, setJsonError] = useState<boolean>(false);
  const [cards, setCards] = useState<Card[]>();
  const CardComponent = React.lazy(
    () => import(`../activityCards/cards/${type}Card/${type}Card`),
  );

  /* const dispatch = useAppDispatch(); */
  /* useEffect(() => { */
  /*   dispatch(setIsEditable(true)) */
  /* }, [dispatch]) */

  useEffect(() => {
    import(`../activityCards/cards/${type}Card/example.json`)
      .then((json) => {
        setCards(json.cards);
        setJsonError(false);
      })
      .catch((err) => {
        console.error("json faild to load!!", err);
        setJsonError(true);
      });
  }, [staticTypes, type]);

  const resource: Resource = {
    PK: "unknown",
    created: "2024-04-09T15:58:54.337Z",
    modified: "2024-04-09T15:58:54.337Z",
    SK: "RESOURCE",
    UUID: "123",
    Qualification: "gcse",
    Subject: {
      id: "history",
      title: {
        en: "History",
        cy: "Hanes",
      },
    },
    Object: {
      themeLevel: "gcse",
      code: "test_resource_code",
      showSidebar: true,
      level: {
        en: "english",
        cy: "welsh",
      },
      subject: {
        en: "History",
        cy: "Hanes",
      },
      branding: "wjec",
      resourceTitle: {
        en: "Test Resource Title",
        cy: "Test Resource Title CY",
      },
      enhancedLearning: false,
      fundedBy: "N/A",
      lessons: [
        {
          active: false,
          progress: 0,
          heroImage:
            "https://resource.download.wjec.co.uk/vtc/2020-21/bL20-21_1-1/elizabeth-coronation.jpg",
          title: {
            en: "Test Lesson Title",
            cy: "Test Lesson Title CY",
          },
          uuid: "456",
          subLessons: [
            {
              cards: [
                {
                  type: type as CardType,
                  uuid: "1011",
                },
              ],
              title: {
                en: "Test Sublesson title",
                cy: "Test Sublesson title CY",
              },
              uuid: "789",
              slug: "slug",
            },
          ],
        },
      ],
    },
  };

  return (
    <FeatureFlag flag={["dev"]}>
      <div className="mx-4 mt-4 mb-5 bg-white shadow p-4 rounded">
        <Suspense
          fallback={
            <div className="text-center py-5">
              <Spinner animation="grow" />
            </div>
          }
        >
          {cards &&
            cards.map((card: any, i: number) => (
              <CardErrorBoundary key={i} type={type}>
                <CardComponent
                  id={"0." + (i + 1)}
                  activityId={`${type}-card-${i}`}
                  key={`${type}-card-${i}`}
                  card={card}
                />
              </CardErrorBoundary>
            ))}

          <Alert show={jsonError} variant="danger">
            <Alert.Heading>JSON Failed to load</Alert.Heading>
            <p>
              File `example.json` failed to load for the `{type} Card`. Are you
              sure the file exists?
            </p>
          </Alert>
        </Suspense>
      </div>
      <FeatureFlag flag={["contenteditor", "dev"]}>
        <ContentEditor resource={resource as UserResource} />
      </FeatureFlag>
    </FeatureFlag>
  );
};

export default Dev;

type CardErrorBoundaryProps = {
  type: string;
  children?: ReactNode;
};
type CardErrorBoundaryState = {
  hasError: boolean;
  error: string;
};
class CardErrorBoundary extends React.Component<
  CardErrorBoundaryProps,
  CardErrorBoundaryState
> {
  constructor(props: CardErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: "",
    };
  }

  static getDerivedStateFromError(error: Error) {
    console.warn(error);
    return {
      hasError: true,
      error: error.message,
    };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="">
          <Alert variant="danger">
            <Alert.Heading>
              `{this.props.type} Card` failed to load
            </Alert.Heading>
            <p>{this.state.error}</p>
          </Alert>
        </div>
      );
    }

    return <>{this.props.children}</>;
  }
}
